import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  NavigationEnd,
  // NavigationStart,
  Router,
} from '@angular/router';
import { InnerPagesService } from '../../common-layout/inner-pages.service';
import { CommonService } from 'src/@services/common.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  previousUrl: string = sessionStorage.getItem('currentURL');
  currentUrl: string = '';
  shouldRedirectToHome: boolean = false;

  constructor(
    public location: Location,
    private router: Router,
    private _iS: InnerPagesService,
    private _cS: CommonService
  ) {
    this.currentUrl = this.router.url;

    // Listen to router events to track navigation
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit(): void {
    sessionStorage.setItem('currentURL', this.currentUrl);
    if (!this.previousUrl || this.previousUrl.includes('page-not-found')) {
      this.shouldRedirectToHome = true;
    } else {
      this.shouldRedirectToHome = false;
    }
  }
  canAccessSummary: boolean = false;
  canAccessprograms: boolean = false;
  redirectToHome() {
    const siteId = JSON.parse(
      sessionStorage.getItem('SupplierDetails') || '{}'
    )?._id;
    this.canAccessSummary = this._iS.canAccessSummary().canViewSummary;
    this.canAccessprograms = this._iS.canAccessPrograms().canViewPrograms;
    this.canAccessSummary
      ? this.router.navigate([`supplier/${siteId}/summary`])
      : this.canAccessprograms
        ? this.router.navigate([`supplier/${siteId}/programs`])
        : this.router.navigate([`supplier/${siteId}/my-profile`]);
  }
  backToLastPage() {
    this.router.navigate([this.previousUrl]);
  }
}
